<template>
    <keep-alive>
        <router-view></router-view>
    </keep-alive>
</template>
<script>
export default {
    name: 'WorkBench',
    data() {
        return {

        }
    },
    created() {
    },
    methods: {

    },
    watch: {

    },
    components: {

    }
}
</script>
<style lang="less" scoped>

</style>
